// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/deals-list-filter-year/deals-list-filter-year.component.scss
// module id = 400
// module chunks = 0